import { bffApi } from "../../autogen/bff-api";
import type { ToolContext, ToolResult } from "./tools";

export const PROCUREMENT_GONE = "PROCUREMENT_GONE";

export const PROCUREMENT_GONE_RESULT: Extract<ToolResult, { ok: false }> = {
  ok: false,
  deviationCode: PROCUREMENT_GONE,
  message:
    "Anskaffelsen finnes ikke lenger: den er forkastet eller slettet. Si det rett ut, beskriv ikke hva " +
    "anskaffelsen har, og tilby ikke å prøve igjen på den. Si i stedet hva brukeren kan gjøre: starte en ny " +
    "anskaffelse eller åpne en annen.",
};

export const isNotFound = (err: unknown): boolean => {
  const e = err as { status?: unknown; originalStatus?: unknown } | undefined;
  return e?.status === 404 || e?.originalStatus === 404;
};

export const procurementIsGone = async (eventId: string, ctx: ToolContext): Promise<boolean> => {
  try {
    await ctx.dispatch(bffApi.endpoints.getSourcingEvent.initiate({ eventId }, { forceRefetch: true })).unwrap();
    return false;
  } catch (err) {
    return isNotFound(err);
  }
};
